// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8f06cf35","455":"3a538c50"}[chunkId] + ".chunk.js";
};